<template>
    <div class="company">
        <button class="btn" @click="save">save</button>
        <button class="btn" @click="importBuildings">import Buildings</button>

        <input type="text" id="simsession" :value="simsession" @input="updateSimsession">


        <label for="pbonus">Production Bonus</label>
        <input id="pbonus" type="number" v-model="pbonus">

        <p>Admin Overhead: {{ admin }}%</p>

        <h3>Buildings</h3>

        <div class="pbuildings">
            <div class="row">
                <div class="col-1 align-self-center text-right">Nr.</div>
                <div class="col-1 text-center">B</div>
                <div class="col align-self-center">Gebäude</div>
                <div class="col align-self-center">Level</div>
                <div class="col align-self-center">Resource</div>
                <div class="col align-self-center text-right">Produktion/h</div>
                <div class="col align-self-center text-right">Produktion/d</div>
            </div>
            <div class="row" v-for="building,key in pbuildings">
                <div class="col-1 align-self-center text-right">{{ key+1 }}</div>
                <div class="col-1"><img v-if="building.id" :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+building.id.image" alt=""></div>
                <div class="col align-self-center">
                    <select class="form-control" v-model="building.id" @change="reset(key)">
                        <option value="undefined">-</option>
                        <option v-for="item in buildings" :value="item">{{ item.name }}</option>
                    </select>
                </div>
                <div class="col align-self-center">
                    <input class="form-control" type="number" v-model="building.level">
                </div>
                <div class="col align-self-center">

                    <div class="row">
                    <div class="col">
                    <select class="form-control" v-if="building.id" v-model="building.resource">
                        <option value="undefined">-</option>
                        <option v-for="item in building.id.production" :value="item">{{ item.resource.name }}</option>
                    </select>
                    </div>
                    <div class="col-1">
                        <img class="building-product-image" v-if="building.resource" :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+building.resource.resource.image" alt="">
                    </div>
                    </div>

                </div>
                    <div class="col align-self-center text-right">
                        <template v-if="building.resource"><div :id="'spark-'+building.resource.resource_db_letter"></div>{{ ((building.resource.anHour/(1-(pbonus/100)))*building.level).toFixed(2) }}</template>
                    </div>
                <div class="col align-self-center text-right">
                    <template v-if="building.resource">{{ (((building.resource.anHour/(1-(pbonus/100)))*building.level)*24).toFixed(2) }}</template>
                </div>
            </div>
        </div>
        <div class="row">
        <div class="col-3 need">
            <h3>Verbrauch</h3>
            <div class="row">
                <div class="col-2">Image</div>
                <div class="col-6 align-self-center text-left">Resource</div>
                <div class="col-2 text-right align-self-center">need/h</div>
                <div class="col-2 text-right align-self-center">need/d</div>
            </div>
            <div class="row" v-for="item in need">
                <div class="col-2"><img :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+item.resource.image" alt=""></div>
                <div class="col-6 align-self-center text-left">{{ item.resource.name }}</div>
                <div class="col-2 text-right align-self-center">{{ item.amount.toFixed(2) }}</div>
                <div class="col-2 text-right align-self-center">{{ (item.amount*24).toFixed(2) }}</div>
            </div>
        </div>
            <div class="col-1"></div>
        <div class="col-4 warehouse">
            <h3>Lager</h3>
            <div class="row">
                <div class="col-2">Image</div>
                <div class="col-6 align-self-center text-left">Resource</div>
                <div class="col-2 text-right align-self-center">Menge</div>
                <div class="col-2 text-right align-self-center">Diff</div>
            </div>


            <div class="row" v-for="item,key in warehouse">
                <div class="col-2"><img :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+item.resource.image" alt=""></div>
                <div class="col-6 align-self-center text-left">{{ item.resource.name }}</div>
                <div class="col-2 text-right align-self-center ">{{ item.amount }}</div>
                <div class="col-2 text-right align-self-center" :class="[need[key]&&(item.amount-need[key].amount*24)<0 ? 'text-danger' : '']">{{ (need[key]?(item.amount-need[key].amount*24).toFixed(0):'') }}</div>
            </div>
        </div>
        </div>


    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .pbuildings {
        width: 1300px;
        margin: 0 auto;
    }

    .building-product-image {
        max-height: 40px;
    }
    img {
        max-height: 60px;
    }

    .need,.warehouse {

        img {
            max-height: 40px;
        }
    }

</style>

<script>

    import * as am4core from '@amcharts/amcharts4/core';
    import * as am4charts from '@amcharts/amcharts4/charts';

    export default {
        name: 'Company',
        data() {
            return {
                player: null,
                pbonus: 0,
                buildings: null,
                pbuildings: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
            };
        },
        computed: {
            simsession() {
                return this.$store.state.simsession;
            },
            resources() {
                return this.$store.state.resources;
            },
            warehouse() {

                let list = {};
                let data = this.$store.state.player.warehouse;
                _.each(data, function(item) {
                    let db_letter = item.kind.db_letter;
                    if(list[db_letter]){
                        list[db_letter].amount += item.amount;
                        list[db_letter].resource = item.kind;
                    } else {
                        list[db_letter] = {amount: item.amount, resource: item.kind};
                    }
                });

                return list;
            },
            admin() {
                let level = 0;
                _.each(this.pbuildings, function(item, key) {
                    if (item.level > 0) {
                        level += parseInt(item.level);
                    }
                });

                let overhead = (((level * 100) / 100 - 1) / 170) * 100;
                return overhead.toFixed(2);
            },
            need() {
                let me = this;
                let list  = {};
                _.each(this.pbuildings, function(building) {
                    if(typeof building.resource != 'undefined'){

                        _.find(me.resources,function(res){
                            if(res.id == building.resource.resource.db_letter) {
                                let amount = building.resource.anHour*building.level/(1-(me.pbonus/100));

                                _.each(res.data.producedFrom, function(pFrom) {
                                    let db_letter = pFrom.resource.db_letter;
                                    if(list[db_letter]){
                                        list[db_letter].amount += pFrom.amount*amount;
                                        list[db_letter].resource = pFrom.resource;
                                    } else {
                                        list[db_letter] = {amount: pFrom.amount*amount, resource: pFrom.resource};
                                    }
                                })

                            }
                        })
                    }
                })

                return list;
            }
        },
        methods: {
            save() {

                window.localStorage.setItem('pbuildings', JSON.stringify(this.pbuildings));
            },


            importBuildings(){
                let me = this;
                fetch('https://sc.gamers-universe.eu/api/getPlayerBuildings.php?sessionid='+this.$store.state.simsession, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                    .then(response => {
                       // this.$store.commit('updatePlayer', response)
                        _.forEach(response, function(building,key) {
                            console.log(building);

                            _.find(me.buildings,function(item){
                                if(item.kind == building.kind) {
                                    me.$set(me.pbuildings[key], 'level', building.size);
                                    me.$set(me.pbuildings[key], 'id', item);
                                }
                            });
                        })
                        console.log(me.pbuildings);


                        me.save();
                    }).catch(err => {
                    console.log(err);
                });
            },

            reset(i,e) {
                this.pbuildings[i].resource = undefined;
                console.log(this.pbuildings[i]);
                console.log(e);
            },
            updateSimsession (e) {
                this.$store.commit('updateSimsession', e.target.value)
            },
            create3dSpark(rid) {
                fetch('https://sc.gamers-universe.eu/api/getHistory.php?mode=7d&id='+rid, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                    .then(response => {

                        var chart = am4core.create("spark-"+rid, am4charts.XYChart);

                        chart.padding(0, 0, 0, 0);

                        chart.data = response;
                        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                        dateAxis.renderer.grid.template.disabled = true;
                        dateAxis.renderer.labels.template.disabled = true;
                        dateAxis.startLocation = 0.5;
                        dateAxis.endLocation = 0.7;
                        dateAxis.cursorTooltipEnabled = false;

                        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                        //valueAxis.min = 0;
                        valueAxis.renderer.grid.template.disabled = true;
                        valueAxis.renderer.baseGrid.disabled = true;
                        valueAxis.renderer.labels.template.disabled = true;
                        valueAxis.cursorTooltipEnabled = false;

                        chart.cursor = new am4charts.XYCursor();
                        chart.cursor.lineY.disabled = true;

                        var series = chart.series.push(new am4charts.LineSeries());
                        series.tooltipText = "{cdate}: [bold]{daymin}";
                        series.dataFields.dateX = "cdate";
                        series.dataFields.valueY = "daymin";
                        series.tensionX = 0.8;
                        series.strokeWidth = 2;

// render data points as bullets
                        var bullet = series.bullets.push(new am4charts.CircleBullet());
                        bullet.circle.opacity = 0;
                        bullet.circle.propertyFields.opacity = "opacity";
                        bullet.circle.radius = 3;
                    })

            },

        },
        components: {},
        beforeMount() {

            let me = this;
            if (JSON.parse(window.localStorage.getItem('pbuildings'))) {
                let buildings = JSON.parse(window.localStorage.getItem('pbuildings'));
                _.each(buildings, function(item, key) {

                    console.log(this);
                    me.$set(me.pbuildings[key], 'level', item.level);
                    me.$set(me.pbuildings[key], 'id', item.id);
                    me.$set(me.pbuildings[key], 'resource', item.resource);
                });

            }

            this.pbonus = parseInt(window.localStorage.getItem('pbonus'));



            if (JSON.parse(window.localStorage.getItem('buildings'))) {
                this.$set(this, 'buildings', JSON.parse(window.localStorage.getItem('buildings')));
            }
            else {
                fetch('https://sc.gamers-universe.eu/api/getBuildings.php', {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                    .then(response => {
                        this.buildings = _.orderBy(response, ['name'], ['asc']);

                        window.localStorage.setItem('buildings', JSON.stringify(this.buildings));
                        console.log(this.buildings);
                    }).catch(err => {
                    console.log(err);
                });
            }


            console.log(this);

        },
        watch: {
            simsession() {
                window.localStorage.setItem('simsession', this.simsession);

            },
            pbuildings() {
                console.log('pbuildings');
                window.localStorage.setItem('pbuildings', JSON.stringify(this.pbuildings));

            },
            pbonus() {
                window.localStorage.setItem('pbonus', this.pbonus);
            },
            warehouseInput() {


                window.localStorage.setItem('warehouse', this.warehouseInput);

            },
        },
    };
</script>
